module.exports = __webpack_public_path__ + "media/svg/mc-fed9edeb.svg";